import { defineComponent, ref } from 'vue';
import { Navigation, FreeMode } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/less';
import 'swiper/less/navigation';
import 'swiper/less/free-mode';
import { useRouter } from 'vue-router';
export default defineComponent({
  name: 'SwiperContestList',
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  setup: function () {
    var router = useRouter();
    var onClickItem = function (item) {
      router.push({
        name: 'ItemDetail',
        params: {
          id: item.contestId
        }
      });
    };
    var btnPrevRef = ref();
    var btnNextRef = ref();
    return {
      modules: [Navigation, FreeMode],
      onClickItem: onClickItem,
      btnPrevRef: btnPrevRef,
      btnNextRef: btnNextRef
    };
  }
});